<template>
	<v-card>
		<v-card-title>
			<v-icon
				icon="$arrowDown"
				start
			/>
			<translate>Download refund files</translate>
		</v-card-title>
		<v-card-text>
			<span>
				<translate>
					Here are the new refund files that have not been downloaded yet. Please upload these to the bank for processing.
				</translate>
			</span>
			<model-backend-table
				v-model="items"
				v-model:options="options"
				endpoint="/bo/bankingfiles/refundexportfiles"
				:headers="tableHeaders"
				:server-items-length="totalItems"
			>
				<template #item.date="{ item }">
					<a :href="`/bo/bankingfiles/downloadRefundExportFile?id=${item.id}`">
						{{ item.date }}
					</a>
				</template>
				<template #item.num_transfers="{ item }">
					<a :href="`/bo/bankingfiles/downloadRefundExportFile?id=${item.id}`">
						{{ item.numTransfers }}
					</a>
				</template>
				<template #item.sum_transfers="{ item }">
					<span
						v-if="item.sumTransfers < 0"
						class="negative-currency"
					>
						<a :href="`/bo/bankingfiles/downloadRefundExportFile?id=${item.id}`">
							€ {{ item.sumTransfers }}
						</a>
					</span>
					<span v-else>
						<a :href="`/bo/bankingfiles/downloadRefundExportFile?id=${item.id}`">
							€ {{ item.sumTransfers }}
						</a>
					</span>
				</template>
				<template #item.actions="{ item }">
					<span>
						<v-btn
							variant="text"
							size="small"
							@click="submit(item.id)"
						>
							<translate>Regenerate</translate>
						</v-btn>
					</span>
				</template>
			</model-backend-table>
		</v-card-text>
	</v-card>
</template>

<script>

import {
	axios,
} from '../../services/axios-service';
import {
	debounce,
} from 'lodash';

export default {
	name: 'RefundFiles',

	props: {
		isAdmin: {
			type: Boolean,
			required: true,
		}
	},

	data () {
		return {
			items: [],
			num: 20,
			options: {
			},
			totalItems: 0,
		};
	},

	computed: {
		tableHeaders () {
			const headers = [
				{
					title: this.$gettext('Date'), value: 'date', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Num transfers'), value: 'numTransfers', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Sum transfers'), value: 'sumTransfers', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('ID'), value: 'id', sortable: false, filterable: false,
				},
			];

			if (this.isAdmin) {
				headers.push({
					text: this.$gettext('Admin'), value: 'actions', sortable: false,
				});
			}
			return headers;
		},
	},

	methods: {
		/**
		 * Regenerate the refund file
		 *
		 * @param {number} id
		 */
		submit (id) {
			axios.post('/bo/bankingfiles/regenerateRefundFile', {
				'id': id
			}).then(() => {
				debounce(() => {
					window.location.reload();
				}, 1000)();
			});
		}
	}
};
</script>
